import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const DamagesLayout = lazy(() => import('@/pages/damages/layout'));
const DamageLayout = lazy(() => import('@/pages/damages/[damageId]/layout'));

const DamagesPage = lazy(() => import('@/pages/damages'));
const CreateDamageDraftPage = lazy(() => import('@/pages/damages/create'));
const DamageDraftDetailsPage = lazy(() => import('@/pages/damages/[damageId]/details'));
const UpdateDamageDraftPage = lazy(() => import('@/pages/damages/[damageId]/update'));

export const damageRoutes: RouteConfig = {
  path: '/damages',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: DamagesLayout,
      children: [
        {
          path: '',
          element: DamagesPage,
        },
        {
          path: '/create',
          element: CreateDamageDraftPage,
        },
      ],
    },
    {
      path: '/:damageId',
      layout: DamageLayout,
      children: [
        {
          path: '/details',
          element: DamageDraftDetailsPage,
        },
        {
          path: '/update',
          element: UpdateDamageDraftPage,
        },
      ],
    },
  ],
};
